import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
    // 获取导航列表
    homeCategoryList(data) {
        const params = data
        return request({
            url: urlParams + '/home-category/list',
            type: 'get',
            params: params
        })
    },
    //   导航修改添加
    homeCategoryAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/home-category/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    //   导航删除
    homeCategoryDel(data) {
        const params = data
        return request({
            url: urlParams + '/home-category/del',
            type: 'post',
            params: params
        })
    },
    //   导航状态
    homeCategoryUpdateStatus(data) {
        const params = data
        return request({
            url: urlParams + '/home-category/updateStatus',
            type: 'post',
            params: params
        })
    },
    // 邻里社交列表
    neighboursList(data) {
        const params = data
        return request({
            url: urlParams + '/neighbours-social-contact/list',
            type: 'get',
            params: params
        })
    },
    // 邻里社交添加
    neighboursAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/neighbours-social-contact/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    //   邻里社交删除
    neighboursDel(data) {
        const params = data
        return request({
            url: urlParams + '/neighbours-social-contact/del',
            type: 'post',
            params: params
        })
    },
    //   邻里社交审核
    neighboursVerify(data) {
        const params = data
        return request({
            url: urlParams + '/neighbours-social-contact/verify',
            type: 'post',
            params: params
        })
    },
    // 邻里社交分类总列表
    communityClassAllList(data) {
        const params = data
        return request({
            url: urlParams + '/community-service-category/totalList',
            type: 'get',
            params: params
        })
    },
    // 邻里社交分类列表
    communityClassList(data) {
        const params = data
        return request({
            url: urlParams + '/community-service-category/list',
            type: 'get',
            params: params
        })
    },
    // 邻里社交分类添加
    communityClassAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/community-service-category/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    //   邻里社交分类删除
    communityClassDel(data) {
        const params = data
        return request({
            url: urlParams + '/community-service-category/del',
            type: 'post',
            params: params
        })
    },
    //   失物招领列表
    lostFoundList(data) {
        const params = data
        return request({
            url: urlParams + '/lost-found/list',
            type: 'get',
            params: params
        })
    },
    //   失物招领修改
    lostFoundAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/lost-found/addUp',
            type: 'post',
            params: params,
            qs: false
        })
    },
    //   失物招领删除
    lostFoundDel(data) {
        const params = data
        return request({
            url: urlParams + '/lost-found/del',
            type: 'post',
            params: params
        })
    },
    //   失物招领领取
    lostFoundReceive(data) {
        const params = data
        return request({
            url: urlParams + '/lost-found/receive',
            type: 'post',
            params: params,
            qs: false
        })
    },
    //场地预约列表
    venueBookingList(data) {
        const params = data
        return request({
            url: urlParams + '/venue-booking/list',
            type: 'get',
            params: params
        })
    },   
    //场地预约修改新增
    venueBookingAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/venue-booking/addUp',
            type: 'post',
            params: params,
            qs:false
        })
    }, 
    //场地预约修改删除
    venueBookingDel(data) {
        const params = data
        return request({
            url: urlParams + '/venue-booking/del',
            type: 'post',
            params: params
        })
    },   
    //场地预约时间列表
    venueBookingTimeList(data) {
        const params = data
        return request({
            url: urlParams + '/venue-booking-time/list',
            type: 'get',
            params: params
        })
    },   
    //场地预约时间修改新增
    venueBookingTimeAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/venue-booking-time/addUp',
            type: 'post',
            params: params,
            qs:false
        })
    }, 
    //场地预约时间修改删除
    venueBookingTimeDel(data) {
        const params = data
        return request({
            url: urlParams + '/venue-booking-time/del',
            type: 'post',
            params: params
        })
    }, 
    //场地预约使用记录
    venueBookingRecordList(data) {
        const params = data
        return request({
            url: urlParams + '/venue-booking-record/list',
            type: 'get',
            params: params
        })
    },
    //场地预约审核
    venueBookingRecordVerify(data) {
        const params = data
        return request({
            url: urlParams + '/venue-booking-record/verify',
            type: 'get',
            params: params
        })
    },  
    //社区服务列表
    communityServiceList(data) {
        const params = data
        return request({
            url: urlParams + '/community-service/list',
            type: 'get',
            params: params
        })
    }, 
    //社区服务新增修改
    communityServiceAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/community-service/addUp',
            type: 'post',
            params: params,
            qs:false
        })
    },  
    //社区服务删除
    communityServiceDel(data) {
        const params = data
        return request({
            url: urlParams + '/community-service/del',
            type: 'post',
            params: params
        })
    },
    //社区服务置顶
    communityServiceTop(data) {
        const params = data
        return request({
            url: urlParams + '/community-service/top',
            type: 'post',
            params: params
        })
    },    
    //社区服务评论
    commentcsList(data) {
        const params = data
        return request({
            url: urlParams + '/user-comment/cs/list',
            type: 'get',
            params: params
        })
    },  
    //删除评论
    userCommentDel(data) {
        const params = data
        return request({
            url: urlParams + '/user-comment/del',
            type: 'post',
            params: params
        })
    },     
    //邻里社交评论列表
    commentnscList(data) {
        const params = data
        return request({
            url: urlParams + '/user-comment/nsc/list',
            type: 'get',
            params: params
        })
    },  
    //到户服务列表
    reachDoorServeList(data) {
        const params = data
        return request({
            url: urlParams + '/reach-door-serve/list',
            type: 'get',
            params: params
        })
    }, 
    //到户服务分类列表
    reachDoorServeClassList(data) {
        const params = data
        return request({
            url: urlParams + '/reach-door-serve-category/list',
            type: 'get',
            params: params
        })
    },
    //到户服务分类新增修改
    reachDoorServeClassAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/reach-door-serve-category/addUp',
            type: 'post',
            params: params,
            qs:false
        })
    },
    //到户服务分类删除
    reachDoorServeClassDel(data) {
        const params = data
        return request({
            url: urlParams + '/reach-door-serve-category/del',
            type: 'post',
            params: params
        })
    },   
    //老人关怀列表
    oldsterCareList(data) {
        const params = data
        return request({
            url: urlParams + '/oldster-care/list',
            type: 'get',
            params: params
        })
    }, 
    //老人关怀分类列表
    oldsterCareClassList(data) {
        const params = data
        return request({
            url: urlParams + '/oldster-care-category/list',
            type: 'get',
            params: params
        })
    },  
    //老人关怀分类新增
    oldsterCareClassAddUp(data) {
        const params = data
        return request({
            url: urlParams + '/oldster-care-category/addUp',
            type: 'post',
            params: params,
            qs:false
        })
    }, 
    //老人关怀分类删除
    oldsterCareClassDel(data) {
        const params = data
        return request({
            url: urlParams + '/oldster-care-category/del',
            type: 'post',
            params: params
        })
    },
    //老人关怀处理
    oldsterCareHandle(data) {
        const params = data
        return request({
            url: urlParams + '/oldster-care/handle',
            type: 'post',
            params: params
        })
    },  
    //到户服务处理
    reachDoorServeHandle(data) {
        const params = data
        return request({
            url: urlParams + '/reach-door-serve/handle',
            type: 'post',
            params: params
        })
    },                                                                              
}